import { Formik, Form, Field, ErrorMessage } from "formik";
import {useState, useRef } from 'react';
import * as Yup from "yup";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/mb_mailer.png";

export default function SignUpPage() {
    const [captchaToken, setCaptchaToken] = useState("");
    const handleCaptcha = (token) => setCaptchaToken(token);
  const navigate = useNavigate();
  const recaptchaRef = useRef();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4">
      <div className="w-[35%]">
        <img src={Logo} alt="MBMailer Logo" />
      </div>
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow">
        <h2 className="text-2xl font-bold text-center mb-6">
          Create Your MBMailer Account
        </h2>
        <Formik
          initialValues={{ name: "", email: "", password: "" }}
          validationSchema={Yup.object({
            name: Yup.string().required("Name is required"),
            email: Yup.string()
              .email("Invalid email")
              .required("Email is required"),
            password: Yup.string()
              .min(6, "Password must be at least 6 characters")
              .required("Password is required"),
          })}
          onSubmit={async (values, { resetForm }) => {
            const newValues = {
              ...values,
              captchaToken
          }
            try {
              await axios.post(
                "https://mbmailer.mb-techs.com/mbmailer/auth/signup",
                newValues,
                {
                  withCredentials: true, // 🔐 This tells the browser to send & accept cookies
                }
              );
              
              toast.success("✅ Account created! Check your email to verify.");
              resetForm();

              // Delay before redirecting to show toast
              setTimeout(() => {
                navigate("/");
              }, 3000);
            } catch (err) {
              toast.error(err?.response?.data?.error || "Signup failed.");
            }
          }}
        >
          <Form className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <Field
                name="name"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage
                name="name"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <Field
                name="email"
                type="email"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <Field
                name="password"
                type="password"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_GOOGLE_ID}
                onChange={handleCaptcha}
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
            >
              Sign Up
            </button>
          </Form>
        </Formik>
        <ToastContainer position="top-center" autoClose={3000} />
        <p className="text-sm text-gray-500 text-center mt-4">
          Have an account?{" "}
          <a href="/login" className="text-blue-600 hover:underline">
            Login
          </a>
        </p>
      </div>
    </div>
  );
}
